import React from "react";
import { PROGRESS_MODE } from "../progressMode";
import FullPageLoader from "./FullPageLoader";
import LoadingOverlay from "./LoadingOverlay";
import LoadingError from "./LoadingError";
import TopProgressBar from "./TopProgressBar";

export default function GlobalLoadingHost({ state, displayMessage, onRetry }) {
  const {
    visible,
    fullScreen,
    overlay,
    error,
    isLoading,
    progressMode,
    progressPercent,
    progressLabel,
  } = state;

  const isDeterminate = progressMode === PROGRESS_MODE.DETERMINATE && progressPercent != null;
  const submessage = isDeterminate
    ? progressLabel || `${progressPercent}% complete`
    : "Please wait while we prepare your data";

  return (
    <>
      <TopProgressBar
        visible={visible && isLoading && !error}
        mode={progressMode}
        percent={progressPercent}
        label={isDeterminate ? `${progressPercent}%` : ""}
      />

      {error && (
        <LoadingError message={error} onDismiss={onRetry} onRetry={onRetry} />
      )}

      {overlay && isLoading && !error && (
        <LoadingOverlay
          message={displayMessage}
          mode={progressMode}
          percent={progressPercent}
          progressLabel={progressLabel}
        />
      )}

      {fullScreen && isLoading && !overlay && !error && (
        <FullPageLoader
          message={displayMessage}
          submessage={submessage}
          mode={progressMode}
          percent={progressPercent}
          progressLabel={progressLabel}
        />
      )}
    </>
  );
}
